// landing page content

export const LandingPageContent = [
    {
        heading: "hi, there!",
        para: "thanks for giving me your precious time and reached out to my portfolio. I'm full stack software engineer specializing in JavaScript libraries and related technologies. here you'll get examples of my work showcasing my expertise in building real world projects."
    }
]



export const LandingPageContent2 = [
    {
        para1: "Think of me as your personal coder or full stacker, your projects are important to me. Got an idea for an app? Need help debugging a project? Just want to chat tech over a virtual cup of coffee? I'm your guy! ☕️ I'm always happy to nerd out about code, brainstorm solutions, or simply connect.",
        para2: "Don't forget to follow me on gitHub and linkedIn to stay updated on my latest projects and tech insights!"
    }
]



export const Slider1Content = [
    {
        id: 1,
        projectTitle: "Tic-Tac-Toe",
        navLink: "/TicTacToe"
    },
    {
        id: 2,
        projectTitle: "Calculator",
        navLink: "/Calculator"
    },
    {
        id: 3,
        projectTitle: "Random Jokes API",
        navLink: "/JokesAPISetup"
    }
]



export const Slider2Content = [
    {
        id: 1,
        projectId: "foodDel",
        projectTitle: "Food Delivery",
        navLink: "https://cakebee.in/",
        className: "food_delivery",
        nextPage: "/Projects",
        aboutpro: "This food delivery app offers a convenient and personalized dining experience, similar to popular e-commerce platforms. Users can easily browse menus, add items to their cart, and securely complete their orders through an intuitive interface.",
        githublink: "https://github.com/Viekesh/foodDeliveryApp",
        contributionHeadline: "Head over to my GitHub repository to explore the source code and contribute to this project!"
    },
    {
        id: 2,
        projectId: "foodDel",
        projectTitle: "Real Estate",
        navLink: "https://landmarkhomes.co.nz/",
        className: "real_estate",
        nextPage: "/Projects",
        aboutpro: "In this project you can upload property information, search property, signin using different methods. we develop this project using react as a frontend and firebase as a backend. Available on GitHub for community contributions and learning.",
        githublink: "https://github.com/Viekesh/Realtor-Clone",
    },
    {
        id: 3,
        projectId: "foodDel",
        projectTitle: "EEE",
        navLink: "/Projects",
        className: "eee",
        aboutpro: "This is my first and foremost project. initially it is a static one and gradually I have added auth feature, call to action, social media integration, admin panel. It is a single page app built using reactjs. right now it is not an online and code is not upload on gitHub repository. If you want to checkout code please contact me."
    },
    {
        id: 4,
        projectId: "foodDel",
        projectTitle: "Edutech",
        navLink: "https://edutech-6116f.web.app/",
        nextPage: "/Projects",
        className: "edutech",
        aboutpro: "This project is in its initial phase which i have build for library. it is an educational app. right now there is no any functionality added to this project.",
        githublink: "https://github.com/Viekesh/EduTech"
    }
]



// project page content

export const ProjectPageContent = [
    {
        id: 1,
        heading: "Hello!!!",
        para1: "I'm currently juggling some exciting projects, some live and others in development. While I have honed my skills in crafting e-commerce platforms, I'm passionate about tackling diverse challenges. Your unique project, regardless of its nature, gets me energized!",
        para2: "Feel free to reach out and discuss your needs. Even if you just want to chat or explore potential collaborations, I'm always happy to connect!",
        contributionHeadline: "Head over to my GitHub repository to explore the source code and contribute to this project!"
    }
]